import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Box } from '@components/main/review/human-validation/models/box';

export interface CapturedMergeTable {
  title: string;
  pageNumber: number;
  pageIndex: number;
  box: Box;
}

@Component({
    selector: 'app-merge-table-summary-panel',
    templateUrl: './merge-table-summary-panel.component.html',
    styleUrls: ['./merge-table-summary-panel.component.scss'],
    standalone: false
})
export class MergeTableSummaryPanelComponent {
  @Input() capturedTables: CapturedMergeTable[] = [];
  @Input() selectedTable: CapturedMergeTable = null;
  @Input() activePageIndex: number = 0;
  @Output() viewTable = new EventEmitter<CapturedMergeTable>();

  onViewTable(table: CapturedMergeTable): void {
    this.viewTable.emit(table);
  }

  onCardClick(table: CapturedMergeTable, event: Event): void {
    const target = event.target as HTMLElement;
    const isInteractiveElement = target.closest('button');

    if (!isInteractiveElement) {
      this.viewTable.emit(table);
    }
  }
}
